var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    t: 1756033386872,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10218,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M501.589333 0c137.898667 0 249.742222 114.631111 249.742223 256S639.431111 512 501.589333 512c-137.955556 0-249.742222-114.631111-249.742222-256 0-141.425778 111.843556-256 249.742222-256z m0 0c137.898667 0 249.742222 114.631111 249.742223 256S639.431111 512 501.589333 512c-137.955556 0-249.742222-114.631111-249.742222-256 0-141.425778 111.843556-256 249.742222-256zM407.893333 597.333333h208.099556c178.176 0 322.616889 148.024889 322.616889 330.638223v21.333333C938.666667 1021.269333 794.168889 1024 616.106667 1024H407.893333C229.774222 1024 85.333333 1023.886222 85.333333 949.304889v-21.333333c0-182.613333 144.440889-330.638222 322.56-330.638223z",
    "p-id": 10219
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.5182aa10492fd7026114e7277de579b2.svg";
export { ForwardRef as ReactComponent };